import { queryFetch } from '../api';
import { useMutation } from '@tanstack/react-query';
import { WebPushReq, WebpushResp } from './types';
import { useShowErrorToast } from '@utils/formHelpers';

export const useCreateWebPush = ({ callback }: { callback: (data: WebpushResp) => void }) => {
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ ...data }: WebPushReq): Promise<WebpushResp> =>
      queryFetch({ url: 'webpush_notifications', data, opt: { method: 'POST' } }),
    onError: (err) => {
      console.error(err);
    },
    onSettled: (data) => {
      if (!data) return;
      const { success, errors } = data as WebpushResp;
      if (errors) showErrorToast(errors);
      if (success) callback(data as WebpushResp);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
